import React from 'react';
import { Group, SegmentedControl, Text } from '@mantine/core';

import { UseProductSalesScopeResult } from '../../hooks/useProductSalesScope';
import type { StoreWithNumber } from '../../pages/price-surveys/types';
import { When } from '../common';
import { SurveyZoneStoreCount } from '../survey/SurveyZoneStoreCount';

type Props = Pick<
    UseProductSalesScopeResult,
    'scope' | 'setScope' | 'canToggle' | 'wideLabel'
> & {
    className?: string;
    storeCount?: number;
    stores?: StoreWithNumber[];
    variant?: 'section' | 'inline';
};

function ProductSalesScopeControl({
    scope,
    setScope,
    canToggle,
    wideLabel,
    className,
    storeCount = 0,
    stores = [],
    variant = 'inline',
}: Props) {
    const isSection = variant === 'section';
    const isWide = scope === 'wide';
    const showWideStoreHint = isWide;

    const data = canToggle
        ? [
              { label: 'Store', value: 'store' },
              { label: wideLabel, value: 'wide' },
          ]
        : [
              {
                  label: isWide ? wideLabel : 'Store',
                  value: scope,
              },
          ];

    return (
        <div
            className={
                isSection
                    ? `flex flex-col items-start gap-1.5 ${className ?? ''}`
                    : className
            }
        >
            <When condition={isSection}>
                <Text size="sm" fw={600} className="text-[#4D5E80]">
                    Sales data scope
                </Text>
            </When>
            <Group gap="sm" align="center" wrap="wrap">
                <SegmentedControl
                    value={scope}
                    onChange={value => {
                        if (!canToggle) {
                            return;
                        }
                        if (value === 'store' || value === 'wide') {
                            setScope(value);
                        }
                    }}
                    data={data}
                    color="primary"
                    size={isSection ? 'sm' : 'xs'}
                    radius="md"
                    className="shrink-0"
                    readOnly={!canToggle}
                />
                <When condition={showWideStoreHint && stores.length > 0}>
                    <SurveyZoneStoreCount stores={stores} />
                </When>
                <When
                    condition={
                        showWideStoreHint &&
                        stores.length === 0 &&
                        storeCount > 0
                    }
                >
                    <Text size="xs" c="dimmed">
                        {storeCount} stores
                    </Text>
                </When>
            </Group>
        </div>
    );
}

export default ProductSalesScopeControl;
